import { ToastTypes } from '../../components/Toast/Toast.types';

const genericErrorShowToastOptions = {
  label: 'Something went wrong.',
  id: 'errorToast',
  toastType: ToastTypes.Error,
  subtext: <div>For immediate assistance please contact the help desk</div>,
};

export default genericErrorShowToastOptions;
